import { Controller } from "@hotwired/stimulus"

import { overlayContainer } from "../../lib/overlayContainer"

export default class extends Controller {
  static values = { options: Object }

  connect() {
    // Spread last so markup that names its own container still wins.
    this.popover = new bootstrap.Popover(this.element, {
      container: overlayContainer(this.element),
      ...(this.hasOptionsValue ? this.optionsValue : {}),
    })
  }

  // Popover extends Tooltip: dispose() alone, see bs_tooltip_controller.
  disconnect() {
    this.popover?.dispose()
  }
}
